var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncementsIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500153,
    y: 0.375977,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#00A88A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4906 31.1406C25.5531 31.1407 25.7953 31.1433 26.159 31.2065L26.1096 32.0136C26.0931 32.4418 25.7307 32.7877 25.3025 32.7877C24.3472 32.7877 23.6884 33.0677 23.2437 33.6277C22.239 34.9124 22.5849 37.4654 22.799 38.3548C22.8649 38.6019 22.799 38.8654 22.6507 39.063C22.486 39.2607 22.2554 39.376 22.0084 39.376H18.9119C18.4507 39.376 18.0884 39.0136 18.0884 38.5525V31.1406H25.4906ZM34.6463 11.8315C34.8159 11.489 35.1947 11.3127 35.5719 11.3967C35.9442 11.4857 36.206 11.8167 36.206 12.1988V19.6947C38.0837 20.0768 39.5002 21.7403 39.5002 23.7283C39.5002 25.7163 38.0837 27.3815 36.206 27.7636V35.2578C36.206 35.6399 35.9442 35.9726 35.5719 36.0599C35.5098 36.0743 35.4463 36.0815 35.3825 36.0813C35.0745 36.0813 34.7879 35.91 34.6463 35.6268C31.614 29.5639 25.5611 29.4931 25.5002 29.4931H17.2649C14.9936 29.4931 13.1472 27.6467 13.1472 25.3754V24.5519H12.3237C11.8691 24.5519 11.5002 24.1846 11.5002 23.7283C11.5002 23.2737 11.8691 22.9048 12.3237 22.9048H13.1472V22.0813C13.1472 19.8116 14.9936 17.9636 17.2649 17.9636H25.4985C25.7456 17.9619 31.6305 17.8615 34.6463 11.8315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementsIco);
export default __webpack_public_path__ + "static/media/announcements-ico.34bcbbeb7885bea42cc230c760023142.svg";
export { ForwardRef as ReactComponent };